const key2 = 'All-in-One AI Writing Copilot'

export default key2
